import DateObject from 'react-date-object';
import persian from 'react-date-object/calendars/persian';
import persian_en from 'react-date-object/locales/persian_en';
export function normalizeDate(value) {
  return String(value || '').replace(/[۰-۹٠-٩]/g, digit => String(digit.charCodeAt(0) >= 0x6f0 ? digit.charCodeAt(0) - 0x6f0 : digit.charCodeAt(0) - 0x660)).trim().replace(/-/g, '/');
}
export function parseJalali(value) {
  const text = normalizeDate(value);
  const match = text.match(/^(\d{4})\/(\d{1,2})\/(\d{1,2})$/);
  if (!match) return null;
  const [year, month, day] = match.slice(1).map(Number);
  if (year < 1300 || year > 1600 || month < 1 || month > 12 || day < 1 || day > 31) return null;
  const date = new DateObject({ year, month, day, calendar: persian, locale: persian_en });
  if (date.year !== year || date.month.number !== month || date.day !== day) return null;
  return { date, formatted: date.format('YYYY/MM/DD') };
}
export function dateRange(start, end) {
  const first = parseJalali(start), last = parseJalali(end);
  if (!first || !last) return { error: 'تاریخ معتبر شمسی وارد کنید؛ مانند ۱۴۰۵/۰۱/۰۱.' };
  const days = Math.round((last.date.toUnix() - first.date.toUnix()) / 86400) + 1;
  if (days < 1) return { error: 'تاریخ پایان باید برابر یا پس از تاریخ شروع باشد.' };
  if (days > 366) return { error: 'بازه انتخابی باید حداکثر ۳۶۶ روز باشد.' };
  return { startDate: first.formatted, endDate: last.formatted };
}
export function defaultDates() {
  const end = new DateObject({ calendar: persian, locale: persian_en });
  return { start: new DateObject(end).subtract(6, 'days').format('YYYY/MM/DD'), end: end.format('YYYY/MM/DD') };
}
export function chartStats(points) {
  if (!points.length) return null;
  const values = points.map(point => point.price);
  const first = values[0], latest = values[values.length - 1];
  return { first, latest, min: Math.min(...values), max: Math.max(...values), average: values.reduce((sum, price) => sum + price, 0) / values.length, change: latest - first, percent: first ? (latest - first) / first * 100 : 0 };
}
